import { render, staticRenderFns } from "./clock-today-feed.vue?vue&type=template&id=1135e064"
import script from "./clock-today-feed.vue?vue&type=script&lang=js"
export * from "./clock-today-feed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports